// removed by extract-text-webpack-plugin
module.exports = {"container":"GalleryPhotoContainer-style__container__993596ac"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/gallery/components/GalleryPhotoContainer-style.scss
// module id = 1055
// module chunks = 4 20 22 24